module.exports = __webpack_public_path__ + "img/icon-premium-active.eef52be7.svg";